define("shared/modifiers/focus-on-destruct", ["exports", "@ember/destroyable", "@ember/runloop", "@ember/service", "ember-modifier", "later/services/errors"], function (_exports, _destroyable, _runloop, _service, _emberModifier, _errors) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/destroyable",0,"@ember/runloop",0,"@ember/service",0,"ember-modifier",0,"later/services/errors"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  function setFocus(instance) {
    /** Note: The element should be focused during the 'next' run loop, as typically
    the functionality causing the modified element to destruct will also trigger
    a rerender of the parent component */
    const element = instance.focusElement;
    try {
      (0, _runloop.next)(() => element?.focus());
    } catch (error) {
      instance.errors.log(new Error(`FocusOnDestruct error: ${error}`), {}, _errors.ErrorSeverity.Debug);
    }
  }

  /**
   * FocusOnDestruct will focus an element when the modified element is destructed. If an element ID is provided,
   * that element will be focused. If no element ID is provided, the last focused element (document.activeElement) before
   * the modified element was inserted will be focused.
   *
   * Example usage:
   * @example
   * <div ... {{focus-on-destruct "focusId"}}>
   *
   * Example usage with SharedModal:
   * Shared::Modal: <div ... {{focus-on-destruct @focusOnDestructId}}>
   * Shared::Modal Parent: <Shared::Modal @focusOnDestructId="elementId" as |modal|>
   */
  let FocusOnDestructModifier = _exports.default = (_class = class FocusOnDestructModifier extends _emberModifier.default {
    constructor(owner, args) {
      super(owner, args);
      // This service is used in the destructor method `setFocus`
      // eslint-disable-next-line ember/no-unused-services
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _defineProperty(this, "focusElement", null);
      (0, _destroyable.registerDestructor)(this, setFocus);
    }
    modify(_element, _ref) {
      let [focusElementId] = _ref;
      const focusElementOverride = focusElementId && document.getElementById(focusElementId);
      /** document.activeElement returns an Element as opposed to an HTMLElement. In the event the
       * document.activeElement is an XML element instead of an HTML element, we will ignore this
       * functionality by setting the activeElement to null */
      const activeElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      this.focusElement = focusElementOverride ? focusElementOverride : activeElement;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});